// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#season-edit-form .react-datepicker-wrapper {\n    width: calc(100% - 30px);\n}\n#season-edit-form .react-datepicker-wrapper > div > input {\n    width: 100% !important;\n}\n#season-edit-form .react-datepicker__input-container {\n    width: 100%;\n}", ""]);
// Exports
module.exports = exports;
